export const tourismClassifiedAPIRoutes = {
  baseUrl: process.env.REACT_APP_TOURISM_CLASSIFIED_API_URL,
  fileUpload: {
    endpoint: 'fileUpload',
    upload: 'uploadImage/upload',
    delete: 'delete',
    uploadBookingDocument: 'uploadBookingDocument/upload',
    deleteBookingDocument: 'deleteBookingDocument'
  },
  city: {
    endpoint: 'cityData',
    getAllCities: 'getAllCities',
    deleteCityData: 'delete',
    updateCityData: 'update',
    addCityData: 'save'
  },
  vendorServiceDetail: {
    endpoint: 'vendor-service',
    saveVendorServiceDetail: 'save',
    getServiceDetailBySearchCriteria: 'getServiceDetailBySearchCriteria',
    getAllToursItineraryByServiceId: 'getAllToursItineraryByServiceId',
    updateToursItinerary: 'updateToursItinerary',
    saveToursItinerary: 'saveToursItinerary',
    deleteToursItineraryById: 'deleteToursItinerary',
    findVendorServiceDetailById: 'findById',
    updateVendorServiceDetail: 'update',
    deleteVendorServiceDetail: 'delete',
    savePackageHotelDetail: 'saveHotelDetail',
    getPackageHotelDetail: 'findAllHotelDetailBySearchCriteria',
    deleteHotelDetailById: 'deleteHotelDetail',
    updateHotelDetail: 'updateHotelDetail',
    getAllInclusionExclusionDetailByServiceIdAndType:
      'getAllInclusionExclusionDetailByServiceIdAndType',
    saveAndUpdateInclusionExclutionDetail:
      'saveAndUpdateInclusionExclutionDetail',
    approveOrRejectServiceDetail: 'approveOrRejectServiceDetail'
  },

  BannerController: {
    endpoint: 'banner',
    saveBanner: 'save',
    findBannerBySearch: 'search',
    findBannerById: 'findById',
    updateBannerSequence: 'updateSequence',
    updateBanner: 'update',
    deleteBanner: 'delete',
    uploadImage: 'uploadImage'
  },

  CurrencyController: {
    endpoint: 'currency',
    savePageDetail: 'save',
    findById: 'findById',
    updatePageDetail: 'update',
    findBySearchCriteria: 'findBySearchCriteria',
    deleteCurrencyDetail: 'delete',
    getAllCurrencies: 'getAllCurrencies'
  },
  BannerLogController: {
    endpoint: 'bannerLog',
    getBannerLogData: 'getBannerLogData'
  },

  enquiryDetail: {
    endpoint: 'booking',
    findEnquiryDetailById: 'findById',
    getEnquiryDetailBySearchCriteria: 'getBookingDetailBySearchCriteria',
    save: 'save',
    updateEnquiryDetail: 'update',
    saveRemark: 'saveRemark',
    getAllRemarkBySearchCriteria: 'getAllRemarkBySearchCriteria'
  },

  otherVendorEnquiryDetail: {
    endpoint: 'OtherVendorBooking',
    findBookingDetailById: 'findById',
    getBookingDetailBySearchCriteria: 'getBookingBySearchCriteria',
    saveBookingDetail: 'save',
    updateBookingDetail: 'update'
  },

  reviewRatingServiceDetail: {
    endpoint: 'customerFeedback',
    getAllCustomerFeedback: 'findAllWithPagination',
    getAllFeedbackBySearchCriteria: 'findAllFeedbackBySearchCriteria'
  },
  ContentController: {
    endpoint: 'page',
    saveContent: 'save',
    findContentBySearch: 'findBySearchCriteria',
    findContentById: 'findById',
    updateContent: 'update',
    deleteContent: 'delete',
    uploadImage: 'uploadImage',
    getAllParentContentDetail: 'getAllParentContentDetail',
    getContentMenuDetails: 'getContentMenuDetails'
  },
  FAQController: {
    endpoint: 'faq',
    saveFAQ: 'save',
    findFAQBySearch: 'search',
    findFAQById: 'findById',
    updateFAQSequence: 'updateSequence',
    updateFAQ: 'update',
    deleteFAQ: 'delete',
    uploadImage: 'uploadImage'
  }
};
